var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "function-status" }, [
    _vm.task.isCanceling
      ? _c("div", { staticClass: "status-txt" }, [
          _c("div", { staticClass: "status-txt" }, [
            _c(
              "div",
              {
                staticClass: "task-waiting",
                staticStyle: { display: "flex", "align-items": "center" }
              },
              [
                _c("img", {
                  staticClass: "my_animation",
                  attrs: {
                    src: require("@/assets/images/imageSaver/loading2.png")
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "status-txt-text",
                    staticStyle: { "padding-left": "5px" }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.common.canceling")))]
                )
              ]
            )
          ])
        ])
      : _c("div", [
          _vm.task.branchType && _vm.task.branchType == "realtime"
            ? _c("div", { staticClass: "status-txt" }, [
                _vm.task.status == 0
                  ? _c("div", [
                      _c("div", {
                        staticClass: "icon-paused",
                        staticStyle: { float: "left" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "status-txt-text",
                          staticStyle: { "padding-left": "5px" }
                        },
                        [_vm._v(_vm._s(_vm.$t("language.cloudSync.paused")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.task.status != 0 && _vm.progress
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "my_animation",
                          attrs: {
                            src: require("@/assets/images/imageSaver/loadingBlue.png")
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "status-txt-text",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [_vm._v(_vm._s(_vm.getPercentAndSpeed))]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.task.status != 0 && !_vm.progress
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "my_animation",
                          attrs: {
                            src: require("@/assets/images/imageSaver/loadingBlue.png")
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "status-txt-text",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("language.cloudSync.realSyncing"))
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _c("div", { staticClass: "status-txt" }, [
                _vm.task.status == 0 && _vm.convertResult
                  ? _c(
                      "div",
                      {
                        staticClass: "status-txt-text",
                        class: "task-" + _vm.convertResult,
                        style:
                          _vm.task.type != 3 && _vm.task.type != 5
                            ? ""
                            : "pointer-events: none;",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.openPopup(1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t("language.common." + _vm.convertResult)
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.task.status == 1 || (_vm.task.status == 2 && _vm.progress)
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "my_animation",
                          attrs: {
                            src: require("@/assets/images/imageSaver/loadingBlue.png")
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "status-txt-text",
                            staticStyle: { "padding-left": "5px" },
                            style: _vm.showProgressPopup
                              ? ""
                              : "pointer-events: none;",
                            on: {
                              click: function($event) {
                                return _vm.openPopup(6)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.getPercentAndSpeed))]
                        ),
                        _vm._v(" "),
                        !_vm.user.vip && _vm.showProgressPopup
                          ? _c(
                              "div",
                              {
                                staticClass: "speed-up-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.openPopup(6)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/vectorImg/speed_up.svg")
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "speed-up-txt" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.taskList.speedUP"))
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.task.status == 2 && !_vm.progress
                  ? _c(
                      "div",
                      {
                        staticClass: "task-waiting",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "my_animation",
                          attrs: {
                            src: require("@/assets/images/imageSaver/loading2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "status-txt-text",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.waiting") + "...")
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6578d8e7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6578d8e7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tab_task_status.vue
// module id = null
// module chunks = 